import { Menu } from '@mantine/core'
import { ChevronDown } from 'lucide-react'

interface BulkAction {
  label: string
  icon?: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  /** For dropdown-style actions (like "Set Status" with sub-options) */
  menu?: { label: string; onClick: () => void }[]
}

interface BulkActionBarProps {
  selectedCount: number
  actions: BulkAction[]
  loading?: boolean
}

const BulkActionBar = ({
  selectedCount,
  actions,
  loading = false,
}: BulkActionBarProps) => {
  if (selectedCount === 0) return null

  return (
    <div className="flex items-center gap-2 rounded-full border border-doubleNickel-brand-100 bg-doubleNickel-brand-50 px-3 py-1 text-xs">
      <span className="font-semibold text-doubleNickel-brand-500">
        {selectedCount} selected
      </span>

      {actions.map((action, index) => (
        <div key={index} className="flex items-center gap-2">
          <span className="text-doubleNickel-gray-300">&middot;</span>

          {action.menu ? (
            <Menu shadow="sm" width={160} position="bottom-start">
              <Menu.Target>
                <button
                  className="flex items-center gap-1 font-medium text-doubleNickel-brand-500 hover:underline disabled:opacity-50"
                  disabled={loading || action.disabled}
                >
                  {action.icon}
                  {action.label}
                  <ChevronDown className="h-3 w-3" />
                </button>
              </Menu.Target>
              <Menu.Dropdown>
                {action.menu.map((menuItem, menuIndex) => (
                  <Menu.Item
                    key={menuIndex}
                    className="text-xs"
                    onClick={menuItem.onClick}
                  >
                    {menuItem.label}
                  </Menu.Item>
                ))}
              </Menu.Dropdown>
            </Menu>
          ) : (
            <button
              className="flex items-center gap-1 font-medium text-doubleNickel-brand-500 hover:underline disabled:opacity-50"
              disabled={loading || action.disabled}
              onClick={action.onClick}
            >
              {action.icon}
              {action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  )
}

export default BulkActionBar
